"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotify = exports.useNotificationBase = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var notification_1 = require("remota-client/module/notification");
var useNotificationBase = function (state) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var getNotification = (0, react_1.useCallback)(function () {
        if (state.messages.length === 0) {
            return undefined;
        }
        return state.messages[0];
    }, [state]);
    var dropNotification = (0, react_1.useCallback)(function (id, date) {
        if (date === void 0) { date = new Date(); }
        dispatch((0, notification_1.drop)(id, date));
    }, [dispatch]);
    return [getNotification, dropNotification];
};
exports.useNotificationBase = useNotificationBase;
var useNotify = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var notify = (0, react_1.useCallback)(function (body, date) {
        if (date === void 0) { date = new Date(); }
        dispatch((0, notification_1.add)(body, date));
    }, [dispatch]);
    return notify;
};
exports.useNotify = useNotify;
